import { path } from "./hooks/types";
import ReadCSVPriceCoursesPage from "./ReadCSVPriceCoursesPage";
export const ReadCSVPriceCourses = {
  Page: ReadCSVPriceCoursesPage,
  path: path,
  Permissions: {
    uploadCsv: "create:Price",
  },
};
